import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiResponse, CatalogoDevolucionDto, SolicitudDevoResumenDto, SolicitudDevoUsuarioDto, SolicitudDevoDetalleUsuarioDto, ArchivoSolDevoDto, SolicitudDevoFrontDto } from '../dto';
import { handleApiError, normalizeHttpError } from '../utils';

@Injectable()
export class WsDevolucionService {

	private endpoint = `/api/WsDevolucion`;
	private genHeader = { context: '.tab-content' };
	constructor(private http: HttpClient, private handler: HttpBackend) { }

	getCatalogo(): Observable<ApiResponse<CatalogoDevolucionDto>> {
		// const headers = { context: ctx };
		return this.http.get<ApiResponse<CatalogoDevolucionDto>>(
			`${this.endpoint}/catalogo`
		).pipe(
			catchError(handleApiError<CatalogoDevolucionDto>())
		);
	}

	getAll(): Observable<ApiResponse<SolicitudDevoUsuarioDto[]>> {
		// const headers = { context: ctx };
		return this.http.get<ApiResponse<SolicitudDevoUsuarioDto[]>>(
			`${this.endpoint}/listar`
		).pipe(
			catchError(handleApiError<SolicitudDevoUsuarioDto[]>())
		);
	}

	get(idSolicitudDevolucion: number): Observable<ApiResponse<SolicitudDevoDetalleUsuarioDto>> {
		// const headers = { context: ctx };

		return this.http.get<ApiResponse<SolicitudDevoDetalleUsuarioDto>>(
			`${this.endpoint}/${idSolicitudDevolucion}`
		).pipe(
			catchError(handleApiError<SolicitudDevoDetalleUsuarioDto>())
		);
	}

	getResumenByOrden(idOrden: number): Observable<ApiResponse<SolicitudDevoResumenDto[]>> {
		// const headers = { context: ctx };

		return this.http.get<ApiResponse<SolicitudDevoResumenDto[]>>(
			`${this.endpoint}/listar-resumen/${idOrden}`
		).pipe(
			catchError(handleApiError<SolicitudDevoResumenDto[]>())
		);
	}

	getArchivos(idSolicitudDevolucion: number): Observable<ApiResponse<ArchivoSolDevoDto[]>> {
		// const headers = { context: ctx };

		return this.http.get<ApiResponse<ArchivoSolDevoDto[]>>(
			`${this.endpoint}/${idSolicitudDevolucion}/archivos`
		).pipe(
			catchError(handleApiError<ArchivoSolDevoDto[]>())
		);
	}

	getContenidoArchivo(idSolicitudDevolucion: number, codigoArchivo: string): Observable<Blob> {
		const headers = { ...this.genHeader };
		// console.log(codigoArchivo);
		// console.log(JSON.stringify(codigoArchivo));
		var link = `${this.endpoint}/${idSolicitudDevolucion}/archivos/${encodeURIComponent(codigoArchivo)}`;
		link = `${this.endpoint}/${idSolicitudDevolucion}/archivos`;
		return this.http.get(
			link,
			{
				params: {
					codigoArchivo
				},
				responseType: 'blob'
			}
		);
	}

	solicitarDevolucion(solicitud: SolicitudDevoFrontDto): Observable<ApiResponse<string>> {
		const headers = {
			context: '.tab-content',
			caption: 'Enviando solicitud de devolución...'
		};
		const formData = new FormData();
		formData.append('IdOrden', solicitud.IdOrden.toString());
		formData.append('IdMotivo', solicitud.IdMotivo.toString());
		formData.append('Motivo', solicitud.Motivo || '');

		solicitud.Observaciones?.forEach(obs => {
			formData.append('Observaciones', obs || '');
		});

		solicitud.Archivos?.forEach(archivo => {
			formData.append('Archivos', archivo, archivo.name);
		});

		return this.http.post<ApiResponse<string>>(
			`${this.endpoint}/solicitar-devolucion`,
			formData,
			{ headers }
		).pipe(
			catchError(handleApiError<string>())
		);
	}
}
